import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/index";

export const getGroupByPlayer = createAsyncThunk(
    "game/getGroupByPlayer",
    async (playerId, thunkAPI) => {
        const response = await api.getGroupByPlayer(playerId);
        return response.data;
    }
);

export const getGameStatus = createAsyncThunk(
    "game/getGameStatus",
    async (groupId, thunkAPI) => {
        const response = await api.getGameStatus(groupId);
        return response.data;
    }
);

export const getAvatar = createAsyncThunk(
    "game/getAvatar",
    async (groupId, thunkAPI) => {
        const response = await api.getAvatar(groupId);
        return response.data;
    }
);

const groupSlice = createSlice({
    name: "game",
    initialState: {
        groupId: "",
        groupName: "",
        players: [],
        playerCount: 0,
        joinedPlayerCount: 0,
        confirmedPlayerCount: 0,
        roleAssignedPlayerCount: 0,
        timerStarts: null,
        timeLimit: 60 * 60,
        classScore: 0,
        gameStarted: false,
        currentMission: null,
        groupScore: 0,
        missions: [],
        avatar: null,
    },
    reducers: {},
    extraReducers: {
        [getGroupByPlayer.fulfilled]: (state, { payload }) => {
            state.groupId = payload.group_id;
            state.groupName = payload.name;
            state.players = payload.players;
            let playerCount = 0,
                joinedPlayerCount = 0,
                confirmedPlayerCount = 0,
                roleAssignedPlayerCount = 0;
            payload.players.forEach((player) => {
                playerCount++;
                if (player.status === "joined") {
                    joinedPlayerCount++;
                } else if (player.status === "confirmed") {
                    confirmedPlayerCount++;
                    joinedPlayerCount++;
                }
                if (player.role !== null && player.role !== "") {
                    roleAssignedPlayerCount++;
                }
            });
            state.playerCount = playerCount;
            state.joinedPlayerCount = joinedPlayerCount;
            state.confirmedPlayerCount = confirmedPlayerCount;
            state.roleAssignedPlayerCount = roleAssignedPlayerCount;
        },
        [getGameStatus.fulfilled]: (state, { payload }) => {
            state.groupId = payload.group_id;
            state.groupName = payload.name;
            state.players = payload.players;
            state.timerStarts = payload.timer_starts;
            state.timeLimit = payload.time_limit;
            state.classScore = payload.class_score;
            state.gameStarted = payload.game_started;
            state.currentMission = payload.game_status.current_mission;
            state.missions = payload.game_status.missions;
            state.groupScore = 0;
            let playerCount = 0,
                joinedPlayerCount = 0,
                confirmedPlayerCount = 0,
                roleAssignedPlayerCount = 0;
            payload.players.forEach((player) => {
                playerCount++;
                if (player.status === "joined") {
                    joinedPlayerCount++;
                } else if (player.status === "confirmed") {
                    confirmedPlayerCount++;
                    joinedPlayerCount++;
                }
                if (player.role !== null && player.role !== "") {
                    roleAssignedPlayerCount++;
                }
            });

            state.missions.forEach((mission) => {
                if(mission.mission_passed === true){
                    state.groupScore++;
                }

                if(mission.swipe_finished === true){
                    state.groupScore++;
                }

                if(mission.mix_n_match_finished === true){
                    state.groupScore++;
                }
            });

            state.playerCount = playerCount;
            state.joinedPlayerCount = joinedPlayerCount;
            state.confirmedPlayerCount = confirmedPlayerCount;
            state.roleAssignedPlayerCount = roleAssignedPlayerCount;
        },
        [getAvatar.fulfilled]: (state, { payload }) => {
            state.avatar = payload;
        },
    },
});

export default groupSlice.reducer;
